module.exports = __webpack_public_path__ + "img/439e1d9.png";